import AppConstants from '../../../../config/app.constants'

class CashDeliveriesController {
  /*@ngInject*/
  constructor(Auth, $state, User, DataCounter, $translate, $q, Modal, $scope, DateUtil, SetupService, Navigation, UsersService,
              BranchFundingSourceService, CashDeliveriesService, ShipmentService, TimezoneList, $rootScope) {
    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.Modal = Modal;
    this.DataCounter = DataCounter
    this.$scope = $scope
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.Navigation = Navigation;
    this.UsersService = UsersService;
    this.BranchFundingSourceService = BranchFundingSourceService;
    this.CashDeliveriesService = CashDeliveriesService;
    this.ShipmentService = ShipmentService;
    this.TimezoneList = TimezoneList;
    this.$rootScope = $rootScope;

    this.model = {
      loading: false,
      search: null,
      branch: User.getUser().branchId,
      dateRange: {},
      selectedFundingSource: null,
      vaultDate: null,
      cashDeliveriesData: [],
      searchText: null,
      currentStats: 'cashDeliveries',
      cashPickupsData: [],
      defaultPageLimit: AppConstants.defaultPageLimit,
      selectedToLocation: null,
      selectedFromLocation: null,
      cashPickupLocationsObj: {
        totalRecords: 0,
        results: []
      },
      cashDeliveryLocationsObj: {
        totalRecords: 0,
        results: []
      },
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      dateRangeOptions: {
        startDate: null,
        endDate: null,
      },
      deliveryPickupDateRangeOptions: {
        startDate: null,
        endDate: null,
      },
      // fundingSourceObj: {
      //   totalRecords: 0,
      //   results: []
      // },
      timezone: null,
      isExportingCashTransactions: false,
      timezoneList: this.TimezoneList.getTimezoneList(),
      loggedInUser: User.getUser().id,
      filterByDeliveryDate: false, 
      filterByPickupDate: false, 
      filterByVaultDate: true
    };

    this.stats = {
      cashDeliveries: 'cashDeliveries',
      cashPickups: 'cashPickups'
    }

    this.sortColumn = "processingDate";
    this.reverseSort = true;
    this.customerId = this.User.getUser().customerUser ? this.User.getUser().customerId : null
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/cash-transactions');
  }

  $onInit() {
    this.model.loading = true;
    this.$q.all([
      this.SetupService.get(this.model.branch),
      this.UsersService.getUserFieldData(this.model.loggedInUser)
    ])
      .then((data) => {
        // this.currentVaultDate = this.DateUtil.getUTCDate(data[0].currentVaultDate);
        this.model.vaultDate = this.DateUtil.convertToDate(data[0].currentVaultDate);
        this.loadDateRangePicker(this.model.vaultDate, this.model.dateRangeOptions, 'dateRange');
        this.model.dateRangeOptions.startDate = moment(this.model.vaultDate).subtract(30, 'days').format('YYYY-MM-DD 00:00:00');
        this.model.dateRangeOptions.endDate = moment(this.model.vaultDate).add(14, 'days').format('YYYY-MM-DD 23:59:59');
        this.model.deliveryPickupDateRangeOptions.startDate = moment(this.model.vaultDate).subtract(30, 'days').format('YYYY-MM-DD 00:00:00');
        this.model.deliveryPickupDateRangeOptions.endDate = moment(this.model.vaultDate).add(14, 'days').format('YYYY-MM-DD 23:59:59');
        this.model.userdetails = data[1];
        this.model.timezone = this.model.userdetails.timezone ? this.model.userdetails.timezone : moment.tz.guess();
        // if (this.model.fundingSourceObj.results.length === 1) {
        //   this.model.selectedFundingSource = this.model.fundingSourceObj.results[0];
        //   this.loadData();
        // }
        this.getCashDeliveryLocations('', 0);
        this.getCashPickupLocations('', 0);
        this.loadData();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.model.loading = false;
      })
  }

  loadDateRangePicker(date, dateRangeOption, modelVal) {
    let currentVaultDate = moment(date).format() || moment();
    this.model[modelVal] = {
      autoApply: true,
      eventHandlers: {
        'apply.daterangepicker': () => {
          this.loadLocationList().then(() => {
            this.loadData();
          })
        }
      },
      ranges: this.getCustomRange(currentVaultDate)
    }
  }

  getCustomRange(currentVaultDate) {
    return {
      'Running 45 Days': [
        moment(currentVaultDate).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'),
        moment(currentVaultDate).add(14, 'days').format('YYYY-MM-DD HH:mm:ss')
      ],
      'Today': [
        moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      ],
      'Current Week': [
        moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'),
        moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')
      ],
      'Current Month': [
        moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')
      ],
      'Current Year': [
        moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'),
        moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')
      ]
    }
  }

  // fundingSourceSearchObj = (searchKey) => {
  //   searchKey = searchKey || '';
  //   const searchObj = {
  //     queryJSON: {
  //       rules: [
  //         {
  //           field: 'branchId',
  //           condition: '=',
  //           data: this.model.branch
  //         },
  //         {
  //           field: 'deliveryReport',
  //           condition: '=',
  //           data: true
  //         },
  //         {
  //           group: {
  //             rules: [{
  //               field: 'locationId',
  //               condition: 'like',
  //               data: '%' + searchKey + '%'
  //             },
  //             {
  //               field: 'sourceName',
  //               condition: 'like',
  //               data: '%' + searchKey + '%'
  //             }
  //             ],
  //             operator: 'OR'
  //           }
  //         }
  //       ],
  //       operator: 'AND'
  //     }
  //   };
  //   return searchObj.queryJSON.rules.length ? searchObj : null;
  // }

  // getBranchFundingSource(searchKey, offset) {
  //   const searchObj = this.fundingSourceSearchObj(searchKey);

  //   return this.BranchFundingSourceService.all(searchObj, offset, AppConstants.defaultPageLimit)
  //     .then((data) => {
  //       if (offset === 0) {
  //         this.model.fundingSourceObj.totalRecords = data.total;
  //         this.model.fundingSourceObj.results = this.locationMapping(data.results);
  //       }
  //       else {
  //         const fundingSource = this.locationMapping(data.results);
  //         this.model.fundingSourceObj.results = this.model.fundingSourceObj.results.concat(fundingSource);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  // locationMapping(fundingSource) {
  //   return fundingSource.map((data) => {
  //     return {
  //       Key: data.locationId + " | " + data.sourceName,
  //       Value: data.locationId,
  //       Id: data.id
  //     }
  //   });
  // }

  loadData() {
    this.model.pagination.page = 1;
    if (this.model.currentStats === this.stats.cashDeliveries) return this.getCashDeliveries();
    else if (this.model.currentStats === this.stats.cashPickups) return this.getCashPickups();
  }

  getCashDeliveries() {

    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    const fromLocationId = this.model.selectedFromLocation ? this.model.selectedFromLocation.Value : null;

    this.model.loadCashDeliveries = true;
    this.CashDeliveriesService.cashDeliveries(this.model.searchText, fromLocationId, this.model.branch, startDate, endDate,
      (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit,
      this.reverseSort, this.sortColumn, this.model.timezone, this.customerId, this.model.filterByDeliveryDate, this.model.filterByVaultDate)
      .then((data) => {
        this.model.pagination.total = data.totalRecords;
        this.model.cashDeliveriesData = data.results;
        // this.resetData();
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        this.model.loadCashDeliveries = false;
      })
  }

  downloadFile(locationId, reportPrefix, reportData) {
    const fileName = reportPrefix.concat('.csv');
    const a = document.createElement("a");
    document.body.appendChild(a);
    const file = new Blob([reportData], { type: 'application/csv' });
    const fileURL = window.URL.createObjectURL(file);
    a.href = fileURL;
    a.download = fileName;
    a.click();
  }

  exportCashDeliveries() {
    // const fromLocationId = this.model.selectedFromLocation.Value;
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    const reportPrefix = `Cash_Deliveries(${this.model.branch})`;
    const fromLocationId = this.model.selectedFromLocation ? this.model.selectedFromLocation.Value : null;

    this.model.isExportingCashDeliveries = true;
    this.CashDeliveriesService.exportCashDeliveries(this.model.searchText, fromLocationId, this.model.branch, startDate, endDate, this.reverseSort, 
                                                    this.sortColumn, this.model.timezone, this.customerId, this.model.filterByDeliveryDate, this.model.filterByVaultDate)
      .then((data) => {
        this.downloadFile(fromLocationId, reportPrefix, data.reportData)
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        this.model.isExportingCashDeliveries = false;
      })
  }

  pageChange() {
    if (this.model.currentStats === this.stats.cashDeliveries) return this.getCashDeliveries();
    else if (this.model.currentStats === this.stats.cashPickups) return this.getCashPickups();
  }

  getOrderType(type) {
    return this.ShipmentService.getOrderType(type);
  }

  resetData() {
    if (((this.model.currentStats === this.stats.cashDeliveries && this.model.cashDeliveriesData.length == 0)
      || (this.model.currentStats === this.stats.cashPickups && this.model.cashPickupsData.length == 0)) && this.model.searchText) {
      this.model.searchText = null;
    }
    // this.model.searchText = null;
  }

  goToServiceHistory(locationId) {
    return this.Navigation.goToServiceHistory(locationId, null, true, null);
  }

  tabSelection(selectedValue) {
    this.model.pagination.page = 1;
    this.model.currentStats = selectedValue;
    // if (this.model.currentStats === this.stats.cashDeliveries && !this.model.selectedFundingSource) {
    //   this.model.cashDeliveriesData = [];
    // }
    this.sortColumn = "processingDate";
    this.reverseSort = true;

    if (!this.model.filterBy) { this.model.filterBy = 'vaultDate'; }
    else if (this.model.filterBy && this.model.filterBy !== 'vaultDate') {
      this.model.filterBy = (this.model.currentStats === this.stats.cashPickups) ? 'pickupDate' : 'deliveryDate';
    }

    this.validateFilterByDate(this.model.filterBy);
    this.loadData();
  }

  getCashPickups() {
    this.model.loadCashPickups = true;
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    const toLocationId = this.model.selectedToLocation ? this.model.selectedToLocation.Value : null;

    this.CashDeliveriesService.cashPickups(this.model.searchText, toLocationId, this.model.branch, startDate, endDate, (this.model.pagination.page - 1) * this.model.pagination.pageLimit, 
                                           this.model.pagination.pageLimit, this.reverseSort, this.sortColumn, this.model.timezone, this.customerId,
                                           this.model.filterByPickupDate, this.model.filterByVaultDate)
      .then((data) => {
        this.model.pagination.total = data.totalRecords;
        this.model.cashPickupsData = data.results;
        // this.resetData();
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        this.model.loadCashPickups = false;
      })
  }

  exportCashPickups() {
    // const fundingSourceLocationId = this.model.selectedFundingSource.Value;
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    const reportPrefix = `Cash_Pickups(${this.model.branch})`;
    const toLocationId = this.model.selectedToLocation ? this.model.selectedToLocation.Value : null;

    this.model.isExportingCashPickups = true;

    this.CashDeliveriesService.exportCashPickups(this.model.searchText, toLocationId, this.model.branch, startDate, endDate, this.reverseSort, this.sortColumn, 
                                                 this.model.timezone, this.customerId, this.model.filterByPickupDate, this.model.filterByVaultDate)
      .then((data) => {
        this.downloadFile(toLocationId, reportPrefix, data.reportData)
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        this.model.isExportingCashPickups = false;
      })
  }

  sortData(column) {
    this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
    this.sortColumn = column;
    this.loadData();
  }

  getCashPickupLocations(searchKey, offset) {
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    const selectedToLocation = this.model.selectedToLocation ? this.model.selectedToLocation.Value : null;

    return this.CashDeliveriesService.cashPickupLocations(this.model.branch, startDate, endDate, this.model.defaultPageLimit, offset, true, this.customerId,
                                                          this.model.filterByPickupDate, this.model.filterByVaultDate)
      .then((data) => {
        if (offset === 0) {
          this.model.cashPickupLocationsObj.totalRecords = data.totalRecords;
          this.model.cashPickupLocationsObj.results = this.locationMapping(data.results);
        }
        else {
          const fromLocation = this.locationMapping(data.results);
          this.model.cashPickupLocationsObj.results = this.model.cashPickupLocationsObj.results.concat(fromLocation);
        }

        if (!this.isLocationFound(this.model.cashPickupLocationsObj.results, selectedToLocation)) this.model.selectedToLocation = null;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getCashDeliveryLocations(searchKey, offset) {
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    const selectedFromLocation = this.model.selectedFromLocation ? this.model.selectedFromLocation.Value : null;

    return this.CashDeliveriesService.cashDeliveryLocations(this.model.branch, startDate, endDate, this.model.defaultPageLimit, offset, true, this.customerId,
                                                            this.model.filterByDeliveryDate, this.model.filterByVaultDate)
      .then((data) => {
        if (offset === 0) {
          this.model.cashDeliveryLocationsObj.totalRecords = data.totalRecords;
          this.model.cashDeliveryLocationsObj.results = this.locationMapping(data.results);
        }
        else {
          const fromLocation = this.locationMapping(data.results);
          this.model.cashDeliveryLocationsObj.results = this.model.cashDeliveryLocationsObj.results.concat(fromLocation);
        }

        if (!this.isLocationFound(this.model.cashDeliveryLocationsObj.results, selectedFromLocation)) this.model.selectedFromLocation = '';
      })
      .catch((err) => {
        console.log(err);
      });
  }

  locationMapping(loc) {
    return loc.map(data => {
      return {
        Key: data.locationId + " | " + data.locationName,
        Value: data.locationId
      }
    });
  }

  getStartDate() {
    if(this.model.filterByVaultDate) {
      return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }
    else {
      return this.model.deliveryPickupDateRangeOptions.startDate ? moment(this.model.deliveryPickupDateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }
  }

  getEndDate() {
    if(this.model.filterByVaultDate) {
      return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }
    else {
      return this.model.deliveryPickupDateRangeOptions.endDate ? moment(this.model.deliveryPickupDateRangeOptions.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }
  }

  loadLocationList() {
    if (this.model.currentStats === this.stats.cashDeliveries) {
      this.model.cashDeliveryLocationsObj.results = [];
      return this.getCashDeliveryLocations('', 0)
    }
    else if (this.model.currentStats === this.stats.cashPickups) {
      this.model.cashPickupLocationsObj.results = [];
      return this.getCashPickupLocations('', 0);
    }
  }

  isLocationFound(results, locationId) {
    if (!locationId) return true;
    const loc = _.find(results, { 'Value': locationId });
    return typeof loc === 'object' ? true : false;
  }

  exportCashTransactions() {
    this.model.isExportingCashTransactions = true;

    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    const toLocationId = this.model.selectedToLocation ? this.model.selectedToLocation.Value : null;
    const fromLocationId = this.model.selectedFromLocation ? this.model.selectedFromLocation.Value : null;

    this.CashDeliveriesService.exportCashTransactions(this.model.searchText, this.model.currentStats, fromLocationId, toLocationId, this.model.branch,
      startDate, endDate, this.reverseSort, this.sortColumn, this.model.timezone, this.customerId,
      this.model.filterByDeliveryDate, this.model.filterByPickupDate, this.model.filterByVaultDate)
      .then(() => { })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          return this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        setTimeout(() => {
          this.model.isExportingCashTransactions = false;
        })
      })
  }

  goToItemHistory(trackingId) {
    this.Navigation.goToItemHistory(trackingId, null);
  }

  validateFilterByDate(filterBy) {
    if(!filterBy) return;
    this.model.filterBy = filterBy;

    if (filterBy === 'vaultDate') {
      this.model.filterByVaultDate = true;
      this.model.filterByDeliveryDate = false;
      this.model.filterByPickupDate = false;
    }
    else if (this.model.currentStats === this.stats.cashDeliveries && filterBy === 'deliveryDate') {
      this.model.filterByVaultDate = false;
      this.model.filterByDeliveryDate = true;
      this.model.filterByPickupDate = false;
    }
    else if (this.model.currentStats === this.stats.cashPickups && filterBy === 'pickupDate') {
      this.model.filterByVaultDate = false;
      this.model.filterByDeliveryDate = false;
      this.model.filterByPickupDate = true;
    }
  }

}

export default CashDeliveriesController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/cash_deliveries/cash_deliveries.controller.js